import React from 'react';
import Modal from '../Modal';
import Dropdown from '../Dropdown/Dropdown';

const inputValue = (v) => (v != null && typeof v !== 'object' ? v : '');

export default function OfficeModal({
    show,
    onClose,
    form,
    onFormChange,
    onSubmit,
    editingId,
    saveError,
    saveBusy,
}) {
    return (
        <Modal show={show} onClose={onClose} className="OfficesList_modal">
            <div className="modal-content">
                <span className="modal-title" style={{ fontSize: 16 }}>
                    {editingId ? 'Edit Office' : 'Add Office'}
                </span>
                <form onSubmit={onSubmit} className="OfficesList_modal_form">
                    <div className="OfficesList_modal_form_fields">
                        <div>
                            <label>Name</label>
                            <input
                                type="text"
                                value={inputValue(form.NAME)}
                                onChange={(e) => onFormChange('NAME', e.target.value)}
                                placeholder="Office name"
                            />
                        </div>
                        <div>
                            <label>Address</label>
                            <input
                                type="text"
                                value={inputValue(form.ADDRESS)}
                                onChange={(e) => onFormChange('ADDRESS', e.target.value)}
                                placeholder="Street address"
                            />
                        </div>
                        <div>
                            <label>City</label>
                            <input
                                type="text"
                                value={inputValue(form.CITY)}
                                onChange={(e) => onFormChange('CITY', e.target.value)}
                                placeholder="City"
                            />
                        </div>
                        <div>
                            <label>State</label>
                            <Dropdown
                                optionsType="states"
                                optionKey="abbr"
                                optionLabelKey="name"
                                valueKey="STATE"
                                label=""
                                placeholder="Select state"
                                disablePortal
                                data={{ ...form }}
                                value={inputValue(form.STATE)}
                                handleParentChange={(data) => onFormChange('STATE', data.STATE)}
                            />
                        </div>
                        <div>
                            <label>Country</label>
                            <Dropdown
                                optionsType="countries"
                                optionKey="value"
                                optionLabelKey="label"
                                valueKey="COUNTRY"
                                label=""
                                placeholder="Select country"
                                disablePortal
                                data={{ ...form }}
                                value={inputValue(form.COUNTRY)}
                                handleParentChange={(data) => onFormChange('COUNTRY', data.COUNTRY)}
                            />
                        </div>
                        <div>
                            <label>Zip</label>
                            <input
                                type="text"
                                value={inputValue(form.ZIP)}
                                onChange={(e) => onFormChange('ZIP', e.target.value)}
                                placeholder="Zip"
                            />
                        </div>
                    </div>
                    {saveError && (
                        <div className="Alert Alert--error" style={{ marginBottom: 12 }}>
                            {saveError}
                        </div>
                    )}
                    <div className="OfficesList_modal_form_footer">
                        <button type="button" className="button-new negative" onClick={onClose}>
                            Cancel
                        </button>
                        <button type="submit" className="button-new positive" disabled={saveBusy}>
                            {saveBusy ? 'Saving…' : editingId ? 'Save' : 'Add Office'}
                        </button>
                    </div>
                </form>
            </div>
        </Modal>
    );
}
